var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "edit-attach-item-component" },
    [
      _vm.isImage
        ? _c("ImagePreview", {
            attrs: { item: _vm.item },
            on: {
              delete: function($event) {
                return _vm.$emit("delete")
              }
            }
          })
        : _c("ItemPreview", {
            attrs: { item: _vm.item },
            on: {
              delete: function($event) {
                return _vm.$emit("delete")
              }
            }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }